import { useNavigate } from 'react-router-dom';
import { Box, Button, LoadingOverlay, Modal, Text, Badge } from '@mantine/core';
import { MessageTemplate, MESSAGE_STATE_WITH_RESULT } from '../model';
import {
  PromiseSendResultModal,
  usePromiseSendResultModal,
} from './SendResultModal';

export const MessageNotFound = () => {
  const navigate = useNavigate();
  return (
    <Modal opened={true} onClose={() => {}} title="找不到訊息設定" centered>
      <Button
        variant="default"
        onClick={() => {
          navigate('/messages');
        }}
      >
        回到列表
      </Button>
    </Modal>
  );
};

export const MessageError = ({ error }: { error?: string }) => {
  const navigate = useNavigate();
  return (
    <Modal opened={true} onClose={() => {}} title="某些東西出錯了" centered>
      {error && <Box>{error}</Box>}
      <Button
        variant="default"
        onClick={() => {
          navigate('/messages');
        }}
      >
        回到列表
      </Button>
    </Modal>
  );
};

export const MessageLoading = () => {
  return (
    <LoadingOverlay
      visible={true}
      zIndex={1000}
      overlayProps={{ radius: 'sm', blur: 2 }}
    />
  );
};

export const MessageCategoryText = ({
  value,
}: {
  value: MessageTemplate['messageCategory'];
}) => {
  const text = value?.parent?.name
    ? `${value.parent.name} | ${value.name}`
    : value.name;

  return text;
};

export const MessageSendingTargetText = ({
  segment,
  segmentSnapshot,
  templateId,
  state,
}: {
  segment: MessageTemplate['segment'];
  segmentSnapshot: MessageTemplate['segmentSnapshot'];
  templateId: MessageTemplate['id'];
  state: MessageTemplate['state'];
}) => {
  const { props, open } = usePromiseSendResultModal();

  let targetText = '未設定';
  if (
    segment?.type === 'condition_segment' &&
    segment.condition === 'all_user'
  ) {
    targetText = '全用戶';
  }

  if (segment?.type === 'list_segment') {
    targetText = '指定名單';
  }

  const hasSendResult = MESSAGE_STATE_WITH_RESULT.includes(state);

  const countUI = !hasSendResult ? (
    segmentSnapshot.userCount >= 0 ? (
      <>
        /<Text component="span">{segmentSnapshot.userCount}</Text>
      </>
    ) : null
  ) : (
    <Badge
      component="span"
      radius="lg"
      p={10}
      onClick={() => {
        open();
      }}
    >
      {segmentSnapshot.userCount >= 0 ? segmentSnapshot.userCount : '計算中'}
    </Badge>
  );

  return (
    <>
      <div className="flex items-center gap-1">
        <Text component="span">{targetText}</Text>
        {countUI}
      </div>
      <PromiseSendResultModal {...props} templateId={templateId} />
    </>
  );
};
